import React, { createContext, useContext, useMemo, useState } from "react";

export const TabsContext = createContext({
  activeTab: "",
  setActiveTab: () => undefined
});

export const TabsContextProvider = ({ children, defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const value = useMemo(
    () => ({
      activeTab,
      setActiveTab
    }),
    [activeTab]
  );

  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};

export const useTabsContext = () => useContext(TabsContext);
